import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { User } from "../../users/_types/user";
import { CaseType } from "../../cases-types/_types/case-type";

export class ContractProcessor extends Resource {
    public override type = 'contractProcessors';
    
    @prop()
    public contractId!: string;
    @prop()
    @required()
    public processorId!: string;
    @prop()
    @required()
    public maxLoadChargePercent!: number;        

    @prop()
    public processor!: User;

    @prop()
    public vipCase?: boolean | null;
    
    @prop()
    public allCasesTypes: boolean = true;
    
    @prop()
    public enableIncomingCalls: boolean = true;

    @prop()
    public allowWithoutCaseType: boolean = true;
}